export const paymentScreens = {
  paymentForm: "paymentForm",
  managePaymentMethods: "managePaymentMethods",
  success: "success",
  modifyOrCancel: "modifyOrCancel",
};
